import React, { Fragment } from 'react';
import { H4, H6, P, UL } from '../../../AbstractElements';

const FormHeader = (props) => {
    const { selected = '', t } = props;
    return (
        <Fragment>
            <div>
                <H4>{t("Sign In To NADA")}</H4>
                <H6>{t('Welcome back! Log in to your account.')}</H6>
            </div>
        </Fragment>
    );
};
export default FormHeader;
